import { create } from 'zustand';
import { IUser } from 'src/static/interface';
import { GetUserInfoConfig } from 'src/service/api';
import { ROLE, ROLE_T, TOKEN } from 'src/static/const';

interface UserStore {
  userInfo: IUser | undefined;
  setUserInfo: (userInfo: IUser | undefined) => void;
  fetchTeacherInfo: () => Promise<void>;
  checkIsUser: () => boolean;
}

export const useUserStore = create<UserStore>((set, get) => ({
  userInfo: undefined,
  
  setUserInfo: (userInfo) => set({ userInfo }),
  
  checkIsUser: () => {
    const role = localStorage.getItem(ROLE);
    const token = localStorage.getItem(TOKEN);
    return role === ROLE_T && !!token;
  },
  
  fetchTeacherInfo: async () => {
    const role = localStorage.getItem(ROLE);
    const token = localStorage.getItem(TOKEN);
    const isUser =  !!token;
    
    
    if (isUser) {
      try {
        const res = await GetUserInfoConfig();
        const { data } = res;
        
        if (!data) {
          set({ userInfo: undefined });
          return;
        }
        
        const arr = data.fullName ? data.fullName.split(" ") : [];
        const name = arr.length >= 2 ? arr[0][0] + arr[1][0] : arr[0]?.[0] || "";
        
        const userInfoData = {
          ...data,
          name, 
        };
        
        set({ userInfo: userInfoData });
      } catch (error) {
        set({ userInfo: undefined });
      }
    } else {
      set({ userInfo: undefined });
    }
  },
}));
